<div class="main-div">
  <mat-card appearance="outlined" class="z-depth">
    <mat-card-title i18n>
      Choose organisation
    </mat-card-title>

    <mat-divider></mat-divider>

    <mat-card-content>
      <div *easLoader="loadingState">
        @if (organisations) {
          <mat-nav-list>
            @for (org of organisations; track org) {
              <a mat-list-item (click)="setOrganisation(org.id)">{{ org.name }}</a>
            }
          </mat-nav-list>
        }
      </div>
    </mat-card-content>
  </mat-card>
</div>
